import { Flowbite, CustomFlowbiteTheme, Footer } from 'flowbite-react'
import { SocialIconList } from '@tribex/stackup-react-ui'
import Link from 'next/link'

const customTheme: CustomFlowbiteTheme = {
  footer: {
    root: {
      base: 'w-full rounded-lg bg-white shadow dark:bg-gray-800 md:flex md:items-center md:justify-between',
      container: 'w-full md:p-8 px-10 pt-8 pb-12',
    },
  },
}

const AppFooter = () => (
  <Flowbite theme={{ theme: customTheme }}>
    <Footer container>
      <div className="w-full text-center">
        <div className="md:flex md:justify-between items-center md:max-h-6">
          <Footer.Copyright
            href="/"
            className="md:w-fit"
            by={`${process.env.NEXT_PUBLIC_APP_NAME} by AngelHack`}
            year={new Date().getFullYear()}
          />
          <div className="flex space-x-3 my-8 justify-center">
            <SocialIconList />
            <Link
              href="https://tribegroup.notion.site/StackUp-Help-Centre-Articles-2025263ef45a801b8539e63065d825b1?pvs=74"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6B7280"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-circle-help-icon lucide-circle-help"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <path d="M12 17h.01" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </Footer>
  </Flowbite>
)
export default AppFooter
